var thumbnails = document.getElementById('thumbnails').getElementsByTagName('img');
var mainImageLink = document.getElementById('main-image-link');
var mainImage = document.getElementById('main-image');

// Build galleryImages array from thumbnails data
const galleryImages = [];
for (let img of thumbnails) {
  const src = img.dataset.largeSrc.startsWith('//') ? 'https:' + img.dataset.largeSrc : img.dataset.largeSrc;
  const size = img.dataset.size.split('x');
  const width = parseInt(size[0], 10);
  const height = parseInt(size[1], 10);
  const alt = 'Description for image ' + img.dataset.index;
  galleryImages.push({ src, width, height, alt });
}

// Thumbnail click handler
Array.from(thumbnails).forEach(function(thumb) {
  thumb.onclick = function() {
    mainImage.src = this.dataset.mainSrc;
    mainImageLink.href = this.dataset.largeSrc;
    mainImageLink.dataset.size = this.dataset.size;
    mainImageLink.dataset.index = this.dataset.index;
  };
});

// Find index function
function findCurrentIndex() {
  let currentSrc = mainImage.src.replace(/^https?:/, ''); // Normalize the URL
  for (let i = 0; i < thumbnails.length; i++) {
    let thumbSrc = thumbnails[i].dataset.mainSrc.replace(/^https?:/, '');
    if (currentSrc === thumbSrc) {
      return i;
    }
  }
  return 0; // Default to first image if not found
}

// PhotoSwipe initialization
mainImageLink.onclick = (e) => {
  e.preventDefault();
  let goToIndex = findCurrentIndex();
  const slideOptions = {
    dataSource: galleryImages,
    index: goToIndex
  };
  const pswp = new PhotoSwipe(slideOptions);
  pswp.init();
};
